export default __webpack_public_path__ + "static/media/newsprint.8020a4b7.png";